<fui-rows [formGroup]="editService.formGroup">
    <ng-container formGroupName="user">
        <fui-row>
            <fui-two-columns>
                <fui-column>
                    <wbo-text-edit-control formControlName="name"
                                           [(ngModel)]="model.data.user.name"></wbo-text-edit-control>
                </fui-column>
                <fui-column>
                    <wbo-password-edit-control formControlName="password" [allowAutocomplete]="false"
                                               [(ngModel)]="model.data.user.password"></wbo-password-edit-control>
                </fui-column>
            </fui-two-columns>
        </fui-row>
        <fui-row>
            <fui-two-columns>
                <fui-column>
                    <wbo-password-edit-control formControlName="pin"
                                               [(ngModel)]="model.data.user.pin"></wbo-password-edit-control>
                </fui-column>
                <fui-column>
                    <wbo-password-edit-control formControlName="swipePin"
                                               [(ngModel)]="model.data.user.swipePin"></wbo-password-edit-control>
                </fui-column>
            </fui-two-columns>
        </fui-row>
        <fui-row>
            <fui-two-columns>
                <fui-column>
                    <wbo-text-edit-control formControlName="employeeCode"
                                           [(ngModel)]="model.data.user.employeeCode"></wbo-text-edit-control>
                </fui-column>
                <fui-column>
                    <fui-tandem-field>
                        <wbo-checkbox-edit-control formControlName="hasBiometric"
                                                   [readonly]="!model.data.user.enableBiometric"
                                                   [(ngModel)]="model.data.user.hasBiometric"></wbo-checkbox-edit-control>
                        <wbo-checkbox-edit-control formControlName="wpsRestricted"
                                                   [(ngModel)]="model.data.user.wpsRestricted"></wbo-checkbox-edit-control>
                    </fui-tandem-field>
                </fui-column>
            </fui-two-columns>
        </fui-row>
    </ng-container>
</fui-rows>
